<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="fuel.fuelType; else addTitle">Edit Fuel</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-form-field>
        <mat-select placeholder="Type *" [(value)]="selectedType" name="type" formControlName="type">
          <mat-option value="100LL">100LL</mat-option>
          <mat-option value="Jet-A">Jet-A</mat-option>
          <mat-option value="Jet-A-Premix/Prist">Jet-A-Premix/Prist</mat-option>
          <mat-option value="MOGAS">MOGAS</mat-option>
          <mat-option value="UL94">UL94</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Brand *" [(value)]="selectedBrand" name="brand" formControlName="brand">
          <mat-option value="Unknown">Unknown</mat-option>
          <mat-option value="Other">Other</mat-option>
          <mat-option value="AEG Fuels">AEG Fuels</mat-option>
          <mat-option value="AirBP">AirBP</mat-option>
          <mat-option value="Ascent">Ascent</mat-option>
          <mat-option value="Avfuel">Avfuel</mat-option>
          <mat-option value="Chevron">Chevron</mat-option>
          <mat-option value="Chevron Texaco">Chevron Texaco</mat-option>
          <mat-option value="Epic">Epic</mat-option>
          <mat-option value="Esso">Esso</mat-option>
          <mat-option value="Exxon">Exxon</mat-option>
          <mat-option value="Independent">Independent</mat-option>
          <mat-option value="Mercury">Mercury</mat-option>
          <mat-option value="Mobil">Mobil</mat-option>
          <mat-option value="Phillips">Phillips</mat-option>
          <mat-option value="Titan">Titan</mat-option>
          <mat-option value="Texaco">Texaco</mat-option>
          <mat-option value="World Fuel">World Fuel</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <span matPrefix>$</span>
        <input matInput
               placeholder="Fee *"
               formControlName="fee"
               [(ngModel)]="selectedPrice">
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Service *" [(value)]="selectedService" name="service" formControlName="service">
          <!--<mat-option value="Truck">Truck</mat-option>-->
          <mat-option value="Self Service">Self Service</mat-option>
          <mat-option value="Full Service">Full Service</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput
               placeholder="Note"
               formControlName="note"
               [(ngModel)]="fuel.otherInfo"
               maxlength="50">
        <mat-hint align="end" *ngIf="fuel.otherInfo">{{fuel.otherInfo.length}} / 50</mat-hint>
      </mat-form-field>
    </div>
    <p id="business-fuel-disclaimer">Fuel price information will be synced automatically with iFlightPlanner which
      is the official fuel price provider for AOPA. Learn more about iFlightPlanner fuel prices <a href="https://www.aopa.org/travel/fuel-prices" target="_blank">HERE</a></p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Fuel
</ng-template>
